import React, { useEffect, useState } from "react";
import { Box, Checkbox, Divider, Switch, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

import RemoteSelect2 from "./remoteSelect2";
import OrderClientSelect from "./orderClientSelect";
import OrderApplicantDetail from "./orderApplicantDetail";

const CLIENT_LABEL_RENDER = (data) =>
  `[ ${data.code ?? data.id ?? " -- "} ] ${data.name} ${
    data.cname ? `(${data.cname})` : ""
  }`;

const CLIENT_SELECT_PROPS = {
  apiEntity: "client",
  placeholder: "Search Client By ID/ BR / Name ",
  valueField: "_id",
  labelField: "name",
  allowClear: true,
  labelRender: CLIENT_LABEL_RENDER,
  multiple: false,
  searchFields: ["name", "id", "cname", "code"],
  clearable: true,
  sort: { by: "name", order: "asc" },
};

const OrderClientPanel = ({ form, mode = "edit", preQuery }) => {
  const { t } = useTranslation();
  const jointClientValue = form.values?.jointClient;
  const [showJointClient, setShowJointClient] = useState(
    () => !!jointClientValue,
  );

  useEffect(() => {
    if (jointClientValue) {
      setShowJointClient(true);
    }
  }, [jointClientValue]);

  const handlePrimaryClientChange = (value, orderForm) => {
    if (!value || !value.consultants?.length) {
      orderForm.setFieldValue("consultants", []);
    } else {
      orderForm.setFieldValue(
        "consultants",
        value.consultants.map((c) => c._id),
      );
    }
    orderForm.setFieldValue("clientSnapShot", value ?? {});
    orderForm.setFieldValue(
      "professionalInvestor",
      value?.professionalInvestor ?? false,
    );
    orderForm.setFieldValue(
      "mainlandChineseVisitor",
      value?.mainlandChineseVisitor ?? false,
    );
  };

  const handleJointClientChange = (value, orderForm) => {
    orderForm.setFieldValue("jointClientSnapShot", value ?? {});
    if (!value) {
      orderForm.setFieldValue("jointClient", null);
    }
  };

  const handleAddJointClientChange = (event) => {
    const checked = event.currentTarget.checked;
    setShowJointClient(checked);
    if (!checked) {
      form.setFieldValue("jointClient", null);
      form.setFieldValue("jointClientSnapShot", {});
    }
  };

  return (
    <Box>
      {mode === "create" ? (
        <>
          <RemoteSelect2
            form={form}
            name="client"
            {...CLIENT_SELECT_PROPS}
            required
            preQuery={preQuery}
            placeholder={t(CLIENT_SELECT_PROPS.placeholder)}
            onDataChange={handlePrimaryClientChange}
          />
          <OrderClientSelect form={form} name="client" />
          <Switch
            mt="md"
            size="xs"
            type="checkbox"
            label={t("Professional Investor (PI)")}
            checked={form.values.professionalInvestor ?? false}
            onChange={(event) =>
              form.setFieldValue(
                "professionalInvestor",
                event.currentTarget.checked,
              )
            }
          />
          <Switch
            mt="md"
            size="xs"
            type="checkbox"
            label={t("Mainland Chinese Visitor (MCV)")}
            checked={form.values.mainlandChineseVisitor ?? false}
            onChange={(event) =>
              form.setFieldValue(
                "mainlandChineseVisitor",
                event.currentTarget.checked,
              )
            }
          />
        </>
      ) : (
        <OrderApplicantDetail form={form} name="client" />
      )}

      {mode === "create" && (
        <Checkbox
          mt="lg"
          size="xs"
          label={t("Add Joint Client")}
          checked={showJointClient}
          onChange={handleAddJointClientChange}
        />
      )}

      {(mode === "create" ? showJointClient : !!jointClientValue) && (
        <Box mt="md">
          <Divider mb="sm" />
          <Title order={6} mb="sm">
            {t("Joint Client")}
          </Title>
          {mode === "create" ? (
            <>
              <RemoteSelect2
                form={form}
                name="jointClient"
                {...CLIENT_SELECT_PROPS}
                placeholder={t(CLIENT_SELECT_PROPS.placeholder)}
                onDataChange={handleJointClientChange}
              />
              <OrderClientSelect form={form} name="jointClient" />
            </>
          ) : (
            jointClientValue && (
              <OrderApplicantDetail form={form} name="jointClient" />
            )
          )}
        </Box>
      )}
    </Box>
  );
};

export default OrderClientPanel;
